import { useCallback, useEffect, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks'
import {
  clearCookie,
  getCookie,
  isValidEmail,
  setCookie,
  updateLoadingState,
} from '@sales-center/common'
import type { LoginFormState } from '@workwave-tidal/core/login-ui'

export const useActions = () => {
  const dispatch = useAppDispatch()

  const [errorTitle, setErrorTitle] = useState<string>('Sign in failed')
  const [error, setError] = useState<string>('')

  useEffect(() => {
    if (getCookie('deactivated')) {
      setError(getCookie('deactivated')!)
      clearCookie('deactivated')
    }
  }, [])

  const handleValidUser = useCallback(
    (rememberMe: boolean, username: string) => {
      setError('')
      setErrorTitle('')

      if (rememberMe) {
        setCookie('rememberMe', `${username}`, 7 * 24 * 60 * 60)
      } else {
        clearCookie('rememberMe')
      }
      setCookie('loginEmail', `${username}`, 7 * 24 * 60 * 60)
      dispatch(updateLoadingState('hidden'))
    },
    [dispatch],
  )

  const checkWWMUserEmail = useCallback(
    async ({ rememberMe, username }: LoginFormState) => {
      if (!isValidEmail(username)) {
        setErrorTitle('Sign in failed')
        return setError('Need to enter valid email')
      }

      try {
        dispatch(updateLoadingState('visible'))
        handleValidUser(Boolean(rememberMe), username)
        window.location.assign(
          `${process.env.REACT_APP_API_URL}/TenantLogin/GetLoginUrl?email=${encodeURIComponent(username)}`,
        )
      } catch (error) {
        setErrorTitle('Service Connectivity Error')
        setError('Please contact support if issue persists.')
      } finally {
        dispatch(updateLoadingState('hidden'))
      }
    },
    [dispatch, handleValidUser],
  )

  return {
    errorTitle,
    checkWWMUserEmail,
    error,
  }
}
